import React from "react";
export var ValidationErrors = function (_a) {
    var mutationValidationErrors = _a.mutationValidationErrors, title = _a.title, children = _a.children;
    var errors = mutationValidationErrors || [];
    var validationErrors = errors.map(function (error, i) {
        return React.createElement("li", { key: i }, error.message);
    });
    return (React.createElement("div", { style: { display: "inline-block" } },
        React.createElement("p", null, title),
        errors.length > 0 && React.createElement("ul", null, validationErrors),
        children));
};
